/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MinimalProductDto } from './MinimalProductDto';
import {
    MinimalProductDtoFromJSON,
    MinimalProductDtoFromJSONTyped,
    MinimalProductDtoToJSON,
    MinimalProductDtoToJSONTyped,
} from './MinimalProductDto';

/**
 * 
 * @export
 * @interface GetProductListResponse
 */
export interface GetProductListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetProductListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<MinimalProductDto>}
     * @memberof GetProductListResponse
     */
    items: Array<MinimalProductDto>;
}

/**
 * Check if a given object implements the GetProductListResponse interface.
 */
export function instanceOfGetProductListResponse(value: object): value is GetProductListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetProductListResponseFromJSON(json: any): GetProductListResponse {
    return GetProductListResponseFromJSONTyped(json, false);
}

export function GetProductListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(MinimalProductDtoFromJSON)),
    };
}

export function GetProductListResponseToJSON(json: any): GetProductListResponse {
    return GetProductListResponseToJSONTyped(json, false);
}

export function GetProductListResponseToJSONTyped(value?: GetProductListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(MinimalProductDtoToJSON)),
    };
}

